export const urlApiServer = process.env.REACT_APP_API_SERVER_URL || "https://panel.rebornpty.com/api/"

export const urlApiServerImage = process.env.REACT_APP_API_SERVER_IMAGE_URL || "https://panel.rebornpty.com"
